import React from "react";
import { Box, Typography } from "@mui/material";

export interface Props {
  image?: JSX.Element;
  borderThickness?: number;
  borderColor?: string;
  children: JSX.Element | string;
}

export const Heading = ({
  image,
  borderThickness = 1,
  borderColor,
  children,
}: Props): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        borderBottom: borderThickness,
        borderColor: borderColor || "divider",
        alignItems: "center",
        px: 0,
        py: 1,
      }}
    >
      <Box sx={{ mr: 1, mb: -1 }}>{image}</Box>
      <Typography variant="h3" component="h1">
        {children}
      </Typography>
    </Box>
  );
};
